import { useWSModalCustom } from "@wingspanhq/fe-component-library";
import { AddClientModal } from "./index";

export const useAddClientModal = () => useWSModalCustom(AddClientModal);
